<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="700"
  >
    <v-card>
      <v-card-title />
      <v-card-text
        v-if="driver"
      >
        <div class="text-center">
          <v-avatar
            color="primary"
            size="45"
          >
            <v-img
              v-if="driver.image_url"
              :src="driver.image_url"
              alt="avatar"
            />
            <span v-else class="primary white--text" style="font-size: 80%">
              {{ driver.name.slice(0, 2) }}
            </span>
          </v-avatar>
          <p class="mb-0">
            <small>{{ driver.name }}</small>
          </p>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-subtitle
        v-if="formattedDate"
      >
        {{ formattedDate }}のアサイン一覧
      </v-card-subtitle>
      <v-card-text style="height: 50vh;overflow-y: scroll">
        <v-row>
          <v-col
            v-if="orders.length > 0"
          >
            <template
              v-for="order in orders"
            >
              <v-card
                :key="order.id"
                class="mb-5"
              >
                <v-card-text>
                  <v-row dense>
                    <v-col>
                      <v-chip
                        color="info"
                        label
                        x-small
                      >
                        回収先
                      </v-chip>
                      &nbsp;
                      <small
                        class="red--text"
                      >
                        {{ order.preferred_start_time | from_to_linked_time(order.preferred_end_time) }}
                      </small>
                      <h5>{{ order.supplier_location_name }}</h5>
                      <small class="mb-0">
                        {{ order.supplier_location_address }}
                      </small>
                    </v-col>
                    <v-col>
                      <v-chip
                        dark
                        label
                        x-small
                      >
                        運搬先
                      </v-chip>
                      <h5>
                        {{ order.trader_location_name }}
                      </h5>
                      <small class="mb-0">
                        {{ order.trader_location_address }}
                      </small>
                    </v-col>
                    <v-col>
                      <h5 class="mb-0">
                        <v-chip
                          v-if="order.item_name"
                          :title="order.item_name"
                          color="#EEE5CF"
                          label
                          x-small
                        >
                          {{ order.item_name | truncate(10) }}
                        </v-chip>
                        <span v-else>&emsp;</span>
                      </h5>
                      <v-spacer />
                      <h5 class="mb-0">
                        {{ order.packing_name }}&nbsp;{{ order.packing_quantity }}
                      </h5>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
          </v-col>
          <v-col
            v-else
          >
            <h3 class="text-center">登録されていません。</h3>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeButtonClickEvent">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import PrefectureList from '../../../../mixins/PrefectureList'

export default {
  name: 'AllocationDriverScheduleDialog',
  components: {},
  mixins: [
    PrefectureList
  ],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetDate: {
      type: String,
      default: () => null,
    },
    targetDriverId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      driver: null,
      formattedDate: null,
      orders: [],
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.driver = null
      this.formattedDate = null
      this.orders = []
      if (newValue) {
        this.setVariable()
      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions('DriverMasterUser', {
      fetchDriver: 'show',
    }),
    ...mapActions('DriverAllocationDriverAssign', {
      fetchDriverSchedule: 'index',
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    /**
     * 表示データの取得
     */
    setVariable () {
      let date = this.$dayjs(this.targetDate)
      this.formattedDate = date.format('YYYY年MM月DD日')
      this.formattedDate = this.formattedDate + '(' + this.weekLabel(date.day()) + ')'

      this.fetchDriver({id: this.targetDriverId}).then((content) => {
        this.driver = content
      })
      this.fetchDriverSchedule({ driver_id: this.targetDriverId, target_date: this.targetDate }).then((content) => {
        this.orders = content.schedules
      })
    },
    /**
     * 週を表す数値を曜日に変換して返す.
     * @param num { Number } 週番号
     * @return {string}
     */
    weekLabel(num) {
      let label = null
      switch (num) {
        case 0:
          label = '日'
          break
        case 1:
          label = '月'
          break
        case 2:
          label = '火'
          break
        case 3:
          label = '水'
          break
        case 4:
          label = '木'
          break
        case 5:
          label = '金'
          break
        case 6:
          label = '土'
          break
        default:
          label = ''
          break
      }
      return label
    },
  }
}
</script>
